<template>
  <div>
    <kye-form>
      <kye-form-item label="组织名称">
        <search-tips
          ref="searchTips"
          style="width:170px;"
          v-model="departmentName"
          :historyId="historyId"
          :showSearchIcon="true"
          :axios="axios"
          :searchUrl="searchDeptUrl"
          :formatResult="formatResult"
          :searchParams="searchDeptParams"
          @clearDepartment="clearDepartment"
          @chooseDepartment="chooseDepartment">
        </search-tips>
        <span style="padding-left:16px;">{{ bakMonthLabel }}</span>
      </kye-form-item>
    </kye-form>
    <dept-tree
      ref="deptTree"
      style="height:calc(60vh - 110px);"
      v-loading="load"
      :load="load"
      :init="init"
      :authTree="authTree"
      :accordion="accordion"
      :defaultExpandedKeys="expandedKeys"
      @nodeClick="nodeClick">
    </dept-tree>
  </div>
</template>

<script>
  import SearchTips from './search-tips.vue'
  import DeptTree from './dept-tree.vue'
  import commonMixins from './mixins'

  export default {
    components: {
      SearchTips,
      DeptTree
    },
    mixins: [commonMixins],
    data () {
      return {
        departmentName: ''
      }
    },
    methods: {
      nodeClick (data) {
        const isNext = this._checkNodeSelect(data) // mixins
        if (isNext === false) {
          return this.$nextTick(() => this.setCheckedDept(null))
        }

        this.departmentName = data.name
      },
      clearDepartment () {
        this.departmentId = ''
        this.departmentName = ''
        this.$emit('clear')
      },
      getCurrentNode () {
        return this.$refs.deptTree.getCurrentNode()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept/dept-tree-search.vue